import {NgModule} from '@angular/core';
import {MetaService} from './services/meta.service';
import { OrdersService } from './services/orders.service';
import { InspectionsService } from './services/inspections.service';
import { SizeChartService } from "./services/size-chart.service";

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [
    MetaService,
    OrdersService,
    InspectionsService,
    SizeChartService
  ]
})
export class CoreModule {
}
